import disableScroll from 'disable-scroll'
import { useEffect } from 'react'

import { Div, Img, Text } from 'components'
import { useSelector } from 'store'
import { selectPublicListing } from 'store/public-listing'
import { selectUserProfile } from 'store/users'
import { COLOR } from 'styles/constants'

import { Overlay } from './styled'

export const PendingReviewMessage = {
  title: 'Listing update in progress',
  descriptionOwner:
    // eslint-disable-next-line quotes
    "You have updated this listing, and we're reviewing the changes. Check back in a bit to see the latest version.",
  descriptionOther:
    // eslint-disable-next-line quotes
    "The property representative has updated this listing, and we're reviewing the changes. Check back in a bit to see the latest version.",
}
export const PendingReviewOverlay: React.FC = () => {
  const { _id: userId } = useSelector(selectUserProfile)
  const { agentId } = useSelector(selectPublicListing)
  const isListingOwner = agentId === userId
  useEffect(() => {
    disableScroll.on()
    document.body.classList.add('no-scroll')
    return () => {
      disableScroll.off()
      document.body.classList.remove('no-scroll')
    }
  }, [])

  return (
    <Overlay>
      <Div $display="flex" $justifyContent="center" $alignItems="center">
        {/* NOTE: Reuse icon from blocked listing */}
        <Img src="/listing/listing-block.svg" alt="pending-review-svg" />
      </Div>
      <Div
        $display="flex"
        $flexDirection="column"
        $justifyContent="center"
        $alignItems="center"
        $mt="55"
      >
        <Text $color={COLOR.BLACK} $bold $mb="10" $size="22px" $lineHeight="32px">
          {PendingReviewMessage.title}
        </Text>
        <Div $maxWidth="550px" $textAlign="center">
          <Text $color={COLOR.BLACK} $lineHeight="28px" $mSize="14px">
            {isListingOwner
              ? PendingReviewMessage.descriptionOwner
              : PendingReviewMessage.descriptionOther}
          </Text>
        </Div>
      </Div>
    </Overlay>
  )
}
